import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from './authentication.service';


@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  retUrlParam: any;
    constructor(
      private authenticationService: AuthenticationService,
      private activatedRoute: ActivatedRoute,
      private router: Router
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
      console.log("iniciando ngOnInit");
      if(route.queryParams.token){
        this.authenticationService.setAccessToken(route.queryParams.token);
      }
      if (!this.authenticationService.isLoggedIn()) {
          console.log("EL usuario no esta autentificado");
          this.router.navigate([ "login" ] , { queryParams: route.queryParams});
          return false;
        }
        console.log("EL usuario SI esta autentificado");
        return true;
    }
}
